module.exports = __webpack_public_path__ + "images/factuals-icon-off-white@2x_71b6a77d859f2013cb104cf2c22711e7.png";